<div class="modal-header">
  <span class="popup-title header-num">{{ configs.title }}</span>
  <button
    type="button"
    class="accello-icon-btn"
    (mousedown)="isActive = true"
    (mouseup)="isActive = false"
    (mouseleave)="isActive = false"
    (click)="activeModal.dismiss('Cross click')"
  >
    <img
      alt="Close"
      [src]="
        isActive
          ? 'assets/images/virtusa-icons/close-dark.svg'
          : 'assets/images/virtusa-icons/close.svg'
      "
    />
  </button>
</div>

<div class="modal-body">
  <div class="execution-list">
    <div
      *ngFor="let item of executionItems"
      class="execution-item p-3 mb-2 rounded"
      [class.dimmed]="hasAnyEnabled && !item.enabled"
    >
      <div class="d-flex align-items-center justify-content-between">
        <div class="item-content flex-grow-1">
          <h6 class="item-title mb-1">{{ item.title }}</h6>
          <p class="item-description mb-0 text-muted">{{ item.description }}</p>
        </div>
        <div class="form-check form-switch ms-3">
          <input
            class="form-check-input"
            type="checkbox"
            [id]="'toggle-' + item.id"
            [(ngModel)]="item.enabled"
            (change)="onToggleChange(item)"
          />
        </div>
      </div>
      
      <!-- ── State A: existing-release dropdown (toggle ON, form hidden) ── -->
      <div *ngIf="item.id === '1' && item.enabled && !showReleaseForm" class="release-dropdown-area mt-3">
        <label class="rfc-label" for="releaseSelect">Release <span class="rfc-required">*</span></label>
        <div class="release-select-wrap mt-1">
          <select
            id="releaseSelect"
            class="form-select release-select"
            [(ngModel)]="selectedReleaseId"
            [disabled]="isLoadingReleases"
          >
            <option value="" disabled>Select release</option>
            <option *ngFor="let r of releases" [value]="r.id">{{ r.name }}</option>
          </select>
          <mat-progress-spinner
            *ngIf="isLoadingReleases"
            mode="indeterminate"
            [diameter]="18"
            class="release-spinner"
          ></mat-progress-spinner>
        </div>
        <button type="button" class="add-release-link mt-2" (click)="addNewRelease()">
          + Add a new release
        </button>
      </div>

      <!-- ── State B: inline create-release card (after clicking "+ Add a new release") ── -->
      <div *ngIf="item.id === '1' && item.enabled && showReleaseForm" class="release-form-card mt-3">

        <!-- Action buttons row -->
        <div class="rfc-header-row mb-2">
          <span class="rfc-label">New Release</span>
          <div class="rfc-action-group">
            <button type="button" class="rfc-btn rfc-btn--confirm" (click)="confirmRelease()"
              [disabled]="releaseForm.invalid || isCreatingRelease" title="Confirm">
              <mat-progress-spinner *ngIf="isCreatingRelease" mode="indeterminate" [diameter]="14"></mat-progress-spinner>
              <img *ngIf="!isCreatingRelease" src="assets/images/virtusa-icons/correct.svg" alt="Confirm">
            </button>
            <button type="button" class="rfc-btn rfc-btn--discard" (click)="cancelRelease()"
              [disabled]="isCreatingRelease" title="Go back">
              <img src="assets/images/virtusa-icons/close-red.svg" alt="Go back">
            </button>
          </div>
        </div>

        <app-dynamic-form
          [form]="releaseForm"
          [formFields]="releaseFields">
        </app-dynamic-form>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer d-flex justify-content-end">
  <button
    type="submit"
    class="btn btn-accello-secondary d-block"
    (click)="activeModal.dismiss('Cross click')"
  >
    Cancel
  </button>
  <button
    type="submit"
    class="btn btn-accello-primary-light d-block d-flex align-items-center gap-2"
    (click)="start()"
    [disabled]="isStartDisabled() || isSaving"
  >
    <mat-progress-spinner
      *ngIf="isSaving"
      mode="indeterminate"
      [diameter]="16"
    ></mat-progress-spinner>
    {{ isSaving ? 'Saving...' : configs.saveBtnText }}
  </button>
</div>
